import React from 'react'
import {connect} from 'react-redux'
import {change as changeFieldValue, Field, formValueSelector, reduxForm} from 'redux-form';
import {Link} from 'react-router-dom';
import {getAdminEmpresa, getOperadorRemarcacao, PERFIL_ADMIN} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import {apenasNumero, renderFieldCpf, renderFieldNumber} from '../../util/inputs';
import Titulo from '../comum/Titulo';
import buscarPedidoRemarcacao from '../../actions/remarcacao/buscarReservasRemarcacao';
import alterarMarcacaoReserva from '../../actions/remarcacao/alterarMarcacaoReserva';
import limparReservasRemarcacao from '../../actions/remarcacao/limparReservasRemarcacao';
import selecionarReservasRemarcacao from '../../actions/remarcacao/selecionarReservasRemarcacao';
import limpaViagens from '../../actions/viagem/limpaViagens';
import selecionarDestino from '../../actions/destino/selecionarDestino';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import adicionarPassageirosIda from '../../actions/passageiro/adicionarPassageirosIda'
import adicionarPassageirosVolta from '../../actions/passageiro/adicionarPassageirosVolta';
import selecionarDescontoUsuario from '../../actions/desconto/selecionarValorDescontoCalculado';
import { adicionarFormasPagamento } from '../../actions/viagem/adicionarFormasPagamento';
import Remarcacao from './Remarcacao';
import ModalConfirmacaoCancelamentoReserva from './ModalConfirmacaoCancelamentoReserva';
import ModalConfirmacaoReservaEmAberto from './ModalConfirmacaoReservaEmAberto';
import {groupArrayOfObjects} from '../../util/arraysUtil';
import selecionarViagemIda from '../../actions/viagem/selecionarViagemIda';
import selecionarViagemVolta from '../../actions/viagem/selecionarViagemVolta';
import {showErrorMsg} from '../../util/messagesUtil';
import ModalConfirmacaoCancelamentoSeguro from './ModalConfirmacaoCancelamentoSeguro';

const selector = formValueSelector('formRemarcacao');

const tipoBuscaCPF = {
    value: 'CPF',
    label: 'Buscar por CPF'
};


export const CabecalhoTabela = () => (
    <div id="header-tabela" className="lista-table d-none d-md-block d-sm-none">
        <div className="row cabecalho-desktop">
            <div className="col">Empresa</div>
            <div className="col">Nome</div>
            <div className="col">CPF</div>
            <div className="col">Data de embarque</div>
            <div className="col">Origem/Destino</div>
            <div className="col">Delimitação</div>
            <div className="col">Embarcou</div>
            <div className="col">Situação</div>
            <div className="col">Pedido</div>
            <div className="col">Poltrona</div>
            <div className="col">Ações</div>
        </div>
    </div>
);

export class PainelGerenciarRemarcacao extends React.Component {
    constructor(props) {
        super(props);
        this.montarParametroPedido = this.montarParametroPedido.bind(this);

        this.state = {
            tipoBusca: tipoBuscaCPF,
            custoCancelamento: '0'
        };
    }

    componentDidMount() {
        this.props.limparReservasRemarcacao();
        this.buscarPedidos();
        this.props.selecionarReservasRemarcacao();
        this.limparTudo()

    }

    limparTudo() {
        this.setState({abaSelecionada: 1});
        this.props.selecionarDestino(null);
        this.props.selecionarOrigem(null);
        this.props.limpaViagens();
        this.props.selecionarViagemIda();
        this.props.selecionarViagemVolta();
        this.props.adicionarPassageirosIda([]);
        this.props.adicionarPassageirosVolta([]);
        this.props.selecionarReservasRemarcacao(null);
        this.props.adicionarFormasPagamento(null);
        this.props.selecionarDescontoUsuario({
            ida: 0.00,
            volta: 0.00
        })
    }

    buscarPedidos() {
        const parametros = {
            idReserva: this.props.numeroBilhete && this.props.numeroBilhete !== '' ? this.props.numeroBilhete : null,
            idPedido: this.props.numeroPedido && this.props.numeroPedido !== '' ? this.props.numeroPedido.trim() : null,
            cpf: this.props.cpf && this.props.cpf !== '' ? apenasNumero(this.props.cpf) : null,
            idEmpresa: this.props.empresaSelecionada.id,

        }
        this.props.buscarPedidoRemarcacao(parametros)
    }

    limparPesquisas() {
        this.props.limparReservasRemarcacao();
        this.props.selecionarReservasRemarcacao();
    }

    // eslint-disable-next-line class-methods-use-this
    montarParametroPedido(values) {
        return {
            id: values.idPedido,
            nome: values.nome,
            telefones: [values.ddd + values.celular],
            email: values.email
        };
    }

    alterarMarcacao(reserva) {
        const reservasSelecionadas = this.props.reservas.filter(f => f.selecionada);
        if (reservasSelecionadas.length > 0) {
            const pedidoId = reservasSelecionadas[0].pedidoId;
            if (pedidoId === reserva.pedidoId) {
                this.props.alterarMarcacaoReserva(reserva)
            } else {
                showErrorMsg('Selecione reservas do mesmo pedido.');
            }
        } else {
            this.props.alterarMarcacaoReserva(reserva)
        }
    }

    exibirBotaoRemarcar() {
        if (!this.props.reservas) {
            return ''
        }
        const selecionadas = this.props.reservas.filter(f => f.selecionada);
        if (selecionadas.length > 0) {
            return <div className="col-12 col-md-1 mt-3 text-right" style={{marginLeft: '-2%'}}>
                <Link to="/painel-destinos?remarcacao=s">
                    <button type="submit" onClick={() => this.selecionarReservas()}
                            className="btn btn-laranja  mt-4">Remarcar
                    </button>
                </Link>
            </div>
        }
        return ''
    }

    exibirBotaoAlterarPoltrona() {
        if (!this.props.reservas) {
            return ''
        }
        const selecionadas = this.props.reservas.filter(f => f.selecionada);
        if (selecionadas.length > 0) {
            return <div className="col-12 col-md-2 mt-3 text-right">
                <button type="submit" style={{backgroundColor: '#b52e85'}}
                        onClick={() => this.selecionarReservasAlteracaoPoltrona()}
                        className="btn btn-laranja  mt-4">Mudar Poltrona
                </button>
            </div>
        }
        return ''
    }

    exibirBotaoCancelar() {
        if (!this.props.reservas) {
            return ''
        }
        const selecionadas = this.props.reservas.filter(f => f.selecionada);
        if (selecionadas.length > 0) {
            return <div className="col-12 col-md-2 mt-4 " style={{marginLeft: '-4%'}}>
                <button type="submit" data-toggle="modal"
                        data-target="#modalConfirmacaoCancelamentoReservas"
                        className="btn btn-vermelho mt-3">Cancelar
                </button>
            </div>
        }
        return ''
    }

    exibirBotaoEmAberto() {
        if (!this.props.reservas) {
            return ''
        }
        const selecionadas = this.props.reservas.filter(f => f.selecionada);
        const reservaEmAberto = this.props.reservas.filter(f => f.situacaoReserva === 'EM_ABERTO' && f.selecionada);

        if (selecionadas.length > 0 && reservaEmAberto.length <= 0) {
            return <div className="col-12 col-md-2 mt-4 ml-3">
                <button type="submit" data-toggle="modal"
                        data-target="#modalConfirmacaoReservasEmAberto"
                        className="btn btn-amarelo mt-3">Deixar aberto
                </button>
            </div>
        }
        return ''
    }


    selecionarReservas() {
        const reservas = this.props.reservas.filter(f => f.selecionada);
        this.props.selecionarReservasRemarcacao(reservas)
    }

    selecionarReservasAlteracaoPoltrona() {
        const reservas = this.props.reservas.filter(f => f.selecionada);
        if (Object.entries(groupArrayOfObjects(reservas, 'itinerarioId')).length > 1) {
            showErrorMsg('Não é permitido alterar poltronas de itinerários diferentes');
            return
        }
        this.props.selecionarReservasRemarcacao(reservas);
        this.props.history.push('/painel-alteracao-poltrona')
    }

    selecionarReservasCancelarSeguro() {
        const reservasSemSeguro = this.props.reservas.filter(f => f.selecionada && !f.numeroSeguro);
        if (reservasSemSeguro.length > 0) {
            showErrorMsg('Existem reservar sem seguro selecionadas para cancelamento');
            return
        }
    }

    exibirReservas() {
        return this.props.reservas
            .map((reserva, index) => <Remarcacao key={reserva.id} reserva={reserva}
                                                 empresaSelecionada={this.props.empresaSelecionada}
                                                 alterarMarcacaoReserva={this.alterarMarcacao.bind(this)}
                                                 indice={index}/>)
    }


    exibirTipoBusca() {
        return (
            <React.Fragment>
                <div className="input-group mb-3 mt-3">
                    <div className="col-md-2 col-12" onClick={() => {
                        this.limparPesquisas();
                        this.props.changeFieldValue('formRemarcacao', 'cpf', null)
                        this.props.changeFieldValue('formRemarcacao', 'numeroBilhete', null)
                    }}>
                        <Field name='numeroPedido' type="text" css="form-control campo-busca"
                               component={renderFieldNumber}
                               onChange={() => this.limparPesquisas()}
                               placeholder="Número do pedido"/>
                    </div>
                    <div className='d-sm-none d-md-block d-none'>
                        <span className='text-center align-items-center align-middle'>Ou</span>
                    </div>
                    <div className='col-12 col-sm-12 text-center d-sm-block d-md-none d-block mb-2'>
                        <span className='text-center align-items-center align-middle'>Ou</span>
                    </div>
                    <div className="col-md-2 col-12" onClick={() => {
                        this.limparPesquisas();
                        this.props.changeFieldValue('formRemarcacao', 'numeroPedido', null);
                        this.props.changeFieldValue('formRemarcacao', 'numeroBilhete', null);
                    }}>
                        <Field name='cpf' type="text" css="form-control campo-busca"
                               component={renderFieldCpf}
                               onChange={() => this.limparPesquisas()}
                               placeholder="CPF do passageiro"/>
                    </div>
                    <div className='d-sm-none d-md-block d-none'>
                        <span className='text-center align-items-center align-middle'>Ou</span>
                    </div>
                    <div className='col-12 col-sm-12 text-center d-sm-block d-md-none d-block mb-2'>
                        <span className='text-center align-items-center align-middle'>Ou</span>
                    </div>
                    <div className="col-md-2 col-12" onClick={() => {
                        this.limparPesquisas();
                        this.props.changeFieldValue('formRemarcacao', 'cpf', null);
                        this.props.changeFieldValue('formRemarcacao', 'numeroPedido', null);
                    }}>
                        <Field name='numeroBilhete' type="text" css="form-control campo-busca"
                               component={renderFieldNumber}
                               onChange={() => this.limparPesquisas()}
                               placeholder="Número do bilhete"/>
                    </div>
                    <div className="col-md-2 col-12 mt-2 mt-md-0 text-center text-md-left">
                        <button type="submit" onClick={() => this.buscarPedidos()} className="btn btn-laranja btn-sm">
                            Buscar
                        </button>
                    </div>
                </div>
            </React.Fragment>
        )
    }

    exibirTabelaReservas() {
        if (this.props.reservas && this.props.reservas.length) {
            return (<div id='tabela-pedidos'>
                    <CabecalhoTabela idEmpresa={this.props.empresaSelecionada.id}/>
                    <div className="lista-table">
                        {this.exibirReservas()}
                    </div>

                </div>
            )
        }
        return <div className="alert alert-warning text-center mt-4" role="alert">Nenhuma reserva localizada que possa
            ser remarcada ou pedido pode estar cancelado. Verifique os parametros informados.</div>;
    }

    exibirBotoes() {
        if (!this.props.reservas) {
            return ''
        }
        const reservasComSeguro = this.props.reservas.filter(f => f.numeroSeguro !== null && f.selecionada);
        const reservaEmAberto = this.props.reservas.filter(f => f.situacaoReserva === 'EM_ABERTO' && f.selecionada);
        const selecionadas = this.props.reservas.filter(f => f.selecionada);
        const reservasSemSeguroSelecionada = selecionadas.filter(f => f.numeroSeguro === null)
        if (selecionadas.length > 0) {
            return <div className='col-12 text-center'>
                <button type="submit" style={{backgroundColor: '#b52e85'}}
                        onClick={() => this.selecionarReservasAlteracaoPoltrona()}
                        className="btn btn-laranja btn-sm ml-2">Mudar Poltrona
                </button>
                <Link to="/painel-destinos?remarcacao=s">
                    <button type="submit" onClick={() => this.selecionarReservas()}
                            className="btn btn-laranja btn-sm ml-2">Remarcar
                    </button>
                </Link>
                <button type="submit" data-toggle="modal"
                        data-target="#modalConfirmacaoCancelamentoReservas"
                        className="btn btn-vermelho btn-sm ml-2 mt-md-0 mt-2 mt-sm-2">Cancelar
                </button>
                {selecionadas.length > 0 && reservaEmAberto.length <= 0 ?
                    <button type="submit" data-toggle="modal"
                            data-target="#modalConfirmacaoReservasEmAberto"
                            className="btn btn-amarelo btn-sm ml-2 mt-md-0 mt-2 mt-sm-2">Deixar aberto
                    </button> : ''}

                {selecionadas.length > 0 && reservasComSeguro.length > 0 && reservasSemSeguroSelecionada.length === 0 ?
                    <button type="submit" data-toggle="modal"
                            onClick={this.selecionarReservasCancelarSeguro()}
                            data-target="#modalConfirmacaoCancelamentoSeguro"
                            className="btn btn-amarelo btn-sm ml-2 mt-md-0 mt-2 mt-sm-2">Cancelar seguro
                    </button> : ''}
            </div>
        }
    }


    render() {
        return (
            <div className="row internas">
                <Titulo texto="Remarcação/Cancelamento de passagem" urlRetorno="/"/>
                <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                    <div className="row mb-4">
                        {this.exibirTipoBusca()}
                        <Autorizacao
                            perfisPermitidos={[getAdminEmpresa(this.props.empresaSelecionada.id),
                                getOperadorRemarcacao(this.props.empresaSelecionada.id), PERFIL_ADMIN]}
                                empresaSelecionada={this.props.empresaSelecionada}>
                            {this.exibirBotoes()}
                        </Autorizacao>
                    </div>
                    <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                        {this.exibirTabelaReservas()}
                    </div>
                    <ModalConfirmacaoCancelamentoReserva buscarPedidos={this.buscarPedidos.bind(this)}/>
                    <ModalConfirmacaoCancelamentoSeguro buscarPedidos={this.buscarPedidos.bind(this)}/>
                    <ModalConfirmacaoReservaEmAberto buscarPedidos={this.buscarPedidos.bind(this)}/>
                </div>
            </div>
        )
    }
}


export const mapStateToProps = state => (
    {
        reservas: state.remarcacao.reservas,
        reservasSelecionadas: state.remarcacao.reservasSelecionadas,
        empresaSelecionada: state.empresaSelecionada,
        tipoPesquisa: selector(state, 'tipoPesquisa'),
        cpf: selector(state, 'cpf'),
        numeroPedido: selector(state, 'numeroPedido'),
        numeroBilhete: selector(state, 'numeroBilhete')

    });


export default connect(mapStateToProps, {
    alterarMarcacaoReserva,
    buscarPedidoRemarcacao,
    limparReservasRemarcacao,
    selecionarReservasRemarcacao,
    limpaViagens,
    selecionarDestino,
    selecionarOrigem,
    adicionarPassageirosIda,
    adicionarPassageirosVolta,
    selecionarDescontoUsuario,
    adicionarFormasPagamento,
    selecionarViagemIda,
    selecionarViagemVolta,
    changeFieldValue
})(reduxForm({
    form: 'formRemarcacao',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(PainelGerenciarRemarcacao));
